var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Appearances;
(function (Appearances) {
    Appearances["primary"] = "primary";
    Appearances["secondary"] = "secondary";
    Appearances["alert"] = "alert";
    Appearances["warning"] = "warning";
    Appearances["success"] = "success";
    Appearances["neel"] = "neel";
    Appearances["nimbu"] = "nimbu";
    Appearances["jamun"] = "jamun";
    Appearances["tawak"] = "tawak";
})(Appearances || (Appearances = {}));
var getBasicStyleProps = function (appearance, palette) {
    switch (appearance) {
        case Appearances.primary:
            return {
                color: palette.white.main,
                backgroundColor: palette.blue.main,
            };
        case Appearances.alert:
            return {
                color: palette.white.main,
                backgroundColor: palette.red.main,
            };
        case Appearances.warning:
            return {
                color: palette.white.main,
                backgroundColor: palette.yellow.main,
            };
        case Appearances.success:
            return {
                color: palette.white.main,
                backgroundColor: palette.green.main,
            };
        case Appearances.neel:
            return {
                color: palette.white.main,
                backgroundColor: palette.neel.main,
            };
        case Appearances.nimbu:
            return {
                color: palette.nimbu.darker,
                backgroundColor: palette.nimbu.main,
            };
        case Appearances.jamun:
            return {
                color: palette.white.main,
                backgroundColor: palette.jamun.main,
            };
        case Appearances.tawak:
            return {
                color: palette.white.main,
                backgroundColor: palette.tawak.main,
            };
        case Appearances.secondary:
        default:
            return {
                color: palette.night.light,
                backgroundColor: palette.stone.light,
            };
    }
};
var getSubtleProps = function (appearance, palette) {
    switch (appearance) {
        case Appearances.primary:
            return {
                color: palette.blue.dark,
                backgroundColor: palette.blue.lightest,
            };
        case Appearances.alert:
            return {
                color: palette.red.dark,
                backgroundColor: palette.red.lightest,
            };
        case Appearances.warning:
            return {
                color: palette.yellow.darker,
                backgroundColor: palette.yellow.lightest,
            };
        case Appearances.success:
            return {
                color: palette.green.dark,
                backgroundColor: palette.green.lightest,
            };
        case Appearances.neel:
            return {
                color: palette.neel.dark,
                backgroundColor: palette.neel.lightest,
            };
        case Appearances.nimbu:
            return {
                color: palette.nimbu.darker,
                backgroundColor: palette.nimbu.lightest,
            };
        case Appearances.jamun:
            return {
                color: palette.jamun.dark,
                backgroundColor: palette.jamun.lightest,
            };
        case Appearances.tawak:
            return {
                color: palette.tawak.darker,
                backgroundColor: palette.tawak.lightest,
            };
        case Appearances.secondary:
        default:
            return {
                color: palette.night.main,
                backgroundColor: palette.stone.light,
            };
    }
};
var getRoundProps = function (round) {
    return round
        ? "\n      padding: 0 12px;\n      border-radius: 20px;\n    "
        : "";
};
var getBasicStyleString = function (styleObject) { return "\n  color: " + styleObject.color + ";\n  background-color: " + styleObject.backgroundColor + ";\n"; };
var getAppearanceProps = function (appearance, palette, isSubtle) {
    var basicStyleObject = __assign({}, getBasicStyleProps(appearance, palette), (isSubtle ? getSubtleProps(appearance, palette) : {}));
    return getBasicStyleString(basicStyleObject);
};
export var Badge = withProps(styled.span)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var _a = props.theme.datashop, palette = _a.palette, weights = _a.weights, appearance = props.appearance, round = props.round, subtle = props.subtle;
    return "\n      height: 20px;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      padding: 0 4px;\n      font-size: 12px;\n      line-height: 16px;\n      box-sizing: border-box;\n      cursor: default;\n      border-radius: 3px;\n      font-weight: " + weights.bold + ";\n      " + getAppearanceProps(appearance, palette, subtle) + "\n      " + getRoundProps(round) + "\n    ";
});
Badge.defaultProps = {
    appearance: Appearances.secondary,
    round: false,
    subtle: false,
};
export { Appearances };
export default Badge;
var templateObject_1;
//# sourceMappingURL=Badge.js.map